import { Component } from '@angular/core';
import { CustomPlaceOrderService } from '@services/custom-place-order.service';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';

@Component({
  selector: 'app-custom-thank-message',
  standalone: false,
  templateUrl: './custom-thank-message.component.html',
  styleUrl: './custom-thank-message.component.scss',
})
export class CustomThankMessageComponent {
  orders = this.orderService.getOrderCode();

  public orderCodeFromHistory = history.state.data.orderB2BSapCode;
  public orderFromHistory = history.state.data;

  ngOnInit() {
    setTimeout(() => {
      this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
    }, 1000);
  }

  constructor(
    private globalMessageService: GlobalMessageService,
    private orderService: CustomPlaceOrderService
  ) {}
}
